// @ts-check
import React from 'react';
import PropTypes from 'prop-types';

import BusComponent from '../BusComponent';
import LocationAnalysisType from '../../enums/LocationAnalysisType';
import SegmentedButton from '../button/SegmentedButton';

/**
 * @typedef Props
 * @property {string} areaTypeId
 * @property {string} mapInstanceId
 * @property {Function} onAreaTypeChange
 * @property {boolean} [allowCustomShape] native insight panel only
 *
 * @typedef State
 * @property {string} areaTypeId
 *
 * @extends {BusComponent<Props, State>}
 */
class AreaTypeSelector extends BusComponent {
    constructor(props, context) {
        super(props, context);
        /** @type {State} */
        this.state = {
            areaTypeId: this.props.areaTypeId,
        };
    }

    onChange = areaTypeId => {
        if (areaTypeId === this.state.areaTypeId) return;

        this.setState({ areaTypeId });

        this.props.onAreaTypeChange(areaTypeId);
    };

    /**
     * RADIUS and DRIVING_TIME, plus POLYGON where the native panel can report on it
     */
    render() {
        const shown = ['RADIUS', 'DRIVING_TIME'];
        if (this.props.allowCustomShape) shown.push('POLYGON');
        const items = Object.keys(LocationAnalysisType)
            .filter(areaTypeId => shown.includes(areaTypeId))
            .map(areaTypeId => ({
                value: areaTypeId,
                label: LocationAnalysisType[areaTypeId].NAME,
                icon: LocationAnalysisType[areaTypeId].ICON,
            }));

        const selectedItem = items.find(item => item.value === this.state.areaTypeId);
        return (
            <div>
                <SegmentedButton
                    options={items}
                    defaultSelected={selectedItem.value}
                    onChange={this.onChange}
                />
            </div>
        );
    }
}

AreaTypeSelector.propTypes = {
    areaTypeId: PropTypes.string.isRequired,
    mapInstanceId: PropTypes.string.isRequired,
    onAreaTypeChange: PropTypes.func.isRequired,
    allowCustomShape: PropTypes.bool,
};

export default AreaTypeSelector;
